var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.25","stroke":"#DCDAD7","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.1 11.134a1 1 0 010 1.732l-6.9 3.984a1 1 0 01-1.5-.866V8.016a1 1 0 011.5-.866l6.9 3.984z","fill":"#DCDAD7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }